import React from 'react';
import PropTypes from 'prop-types';
import handlePlural from '../../util/handlePlural';

TitlesAddedSummary.propTypes = {
	alreadyAddedIsbns: PropTypes.array,
	successfullyAddedIsbns: PropTypes.array,
	invalidIsbns: PropTypes.array,
};

function TitlesAddedSummary({
	alreadyAddedIsbns,
	successfullyAddedIsbns,
	invalidIsbns,
}) {
	const summaryBullet = (titlesByType, description) => (
		<>
			<span className="bold">{description}</span>
			<span className="margin-bottom-5">{titlesByType.join(', ')}</span>
		</>
	);

	const handlePluralIsbnTitle = listLength =>
		handlePlural('ISBN', listLength, true);

	return (
		<div className="titles-added-summary">
			{successfullyAddedIsbns.length
				? summaryBullet(
						successfullyAddedIsbns,
						`Successfully added ${handlePluralIsbnTitle(
							successfullyAddedIsbns.length,
						)}:`,
				  )
				: null}
			{alreadyAddedIsbns.length
				? summaryBullet(
						alreadyAddedIsbns,
						`${handlePluralIsbnTitle(
							alreadyAddedIsbns.length,
						)} already on the list:`,
				  )
				: null}
			{invalidIsbns.length
				? summaryBullet(
						invalidIsbns,
						`Invalid ${handlePluralIsbnTitle(
							invalidIsbns.length,
						)}:`,
				  )
				: null}
		</div>
	);
}

export default TitlesAddedSummary;
